import { Services } from '@/infra/services';
import { type ItemId } from '@/infra/services/catalog/model';

interface GetSellersProps {
  productId: ItemId;
}

export async function getSellers(props: Readonly<GetSellersProps>) {
  const { productId } = props;

  return await Services.Catalog.Product.getSellers({ productId });
}
